import { useQuery } from 'react-query';

import platformService from '../services/platform.service';
import { UserType } from '../users/users.types';

export function useParticipant(): { user: UserType | undefined; isLoading: boolean } {
  const { data, isLoading } = useQuery(['user'], () => platformService.fetchUser());
  return { user: data, isLoading };
}
